import { render, staticRenderFns } from "./RegionalQuestionaire.vue?vue&type=template&id=fb95853a&"
import script from "./RegionalQuestionaire.vue?vue&type=script&lang=js&"
export * from "./RegionalQuestionaire.vue?vue&type=script&lang=js&"
import style0 from "./RegionalQuestionaire.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports